export const YANDEX_METRICS_ID = 95316181;

export const yandexMetricsHit = (path: string) => {
  (window as any).ym(YANDEX_METRICS_ID, 'hit', path);
};
